import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderOpenFront: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-open-front"><path d="M2.75 9.5V3.75H9.94444L12 5.75H21.25V9.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 11.75L2.75006 19.25H21.2501L23 11.75H1Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFolderOpenFront;
